import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AdminRightServiceService {

  constructor() {}

  hasNoAuthorityForModule(moduleName: any): boolean {
    const userRightsJson = localStorage.getItem('admininfo');

    if (userRightsJson) {
      try {
        const parsed = JSON.parse(userRightsJson);
        const userRightsObj = parsed?.roleManagement;

        if (Array.isArray(userRightsObj)) {
          const moduleObj = userRightsObj.find(
            (module: any) => module.moduleName === moduleName
          );
          return moduleObj ? moduleObj.hide : false;
        }
      } catch (error) {
        console.error('Failed to parse admininfo from localStorage:', error);
      }
    }

    return false;
  }

  hasReadOnlyAuthorityForModule(moduleName: any): boolean {
    const userRightsJson = localStorage.getItem('admininfo');

    if (userRightsJson) {
      try {
        const parsed = JSON.parse(userRightsJson);
        const userRightsObj = parsed?.roleManagement;

        if (Array.isArray(userRightsObj)) {
          const moduleObj = userRightsObj.find(
            (module: any) => module.moduleName === moduleName
          );
          return moduleObj ? moduleObj.readOnly : false;
        }
      } catch (error) {
        console.error('Failed to parse admininfo from localStorage:', error);
      }
    } else {
      console.log("No admininfo found in localStorage.");
    }

    return false;
  }
}
